import { Action } from '@ardoq/rxbeach';
import {
  setIsDescriptionExpanded,
  setIsNodeDescriptionExpanded,
} from './actions';

export type NodeDescription = { name: string; text: string };

export type DescriptionState = {
  slideDescription: string | null;
  nodeDescription: NodeDescription | null;
  isDescriptionExpanded: boolean;
  isNodeDescriptionExpanded: boolean;
};

export const hasDescription = ({
  slideDescription,
  nodeDescription,
}: DescriptionState): boolean => Boolean(slideDescription || nodeDescription);

export const isDescriptionShown = ({
  nodeDescription,
  isDescriptionExpanded,
  isNodeDescriptionExpanded,
}: DescriptionState): boolean =>
  nodeDescription ? isNodeDescriptionExpanded : isDescriptionExpanded;

export const toggleDescription = (state: DescriptionState): Action<boolean> => {
  const isShown = isDescriptionShown(state);
  if (state.nodeDescription) return setIsNodeDescriptionExpanded(!isShown);
  return setIsDescriptionExpanded(!isShown);
};
